<template>
  <div class="mb-16">  
    <template v-if="blog">
      <section class="mb-32">
        <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Excluded')[0]" />
      </section>
      <UiContentwrapper>
        <UiFullcolumn>
          <!-- Unified Articles Grid (Static + Dynamic) -->           
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            <div
              v-for="article in mergedArticles"
              :key="article.handle"
              class="w-full group article-hover"
            >
              <!-- Article Image -->
              <NuxtLink
                :to="article.isStatic ? '/the-gravaa-story' : `/blogs/${blogHandle}/${article.handle}`"
              >
                <img
                  v-if="article.isStatic"
                  :src="article.image.src"
                  alt="The Gravaa Story"
                  class="w-full article-image object-cover aspect-[364/243]"
                />
                <UiArticleImage
                  v-else
                  v-if="article.image"
                  :article="article"
                  class="w-full article-image"
                  :modifiers="{
                    auto: 'format,compress',
                    fit: 'crop',
                    crop: 'faces,edges',
                    ar: '364:243'
                  }"
                />
              </NuxtLink>

              <!-- Title + Excerpt -->
              <div class="relative mt-5">
                <NuxtLink
                  :to="article.isStatic ? '/the-gravaa-story' : `/blogs/${blogHandle}/${article.handle}`"
                  class="block"
                >
                  <h4 class="m-0 pb-1">
                    {{ article.title }}
                  </h4>
                </NuxtLink>
                <NuxtLink
                  :to="article.isStatic ? '/the-gravaa-story' : `/blogs/${blogHandle}/${article.handle}`"
                >
                  <p class="xsmall mt-1">{{ article.excerpt }}</p>
                </NuxtLink>
              </div>
            </div>
          </div>
        </UiFullcolumn>
      </UiContentwrapper>
    </template>

    <!-- Fallback if blog doesn't exist -->
    <template v-else>
      <UiContentwrapper>
        <UiFullcolumn>
          <h1 class="mt-32">Sorry, this blog does not exist</h1>
          <p class="small">The blog you are looking for has been removed or never existed.</p>
            <UiButton
            class="btn lightbrown text-white px-10 py-4 rounded-md mt-12 mb-16 w-1/6"
            :to="{ name: 'index' }"
            >
            Back to Home
            </UiButton>
        </UiFullcolumn>
      </UiContentwrapper>
    </template>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useBlogStore } from '@/stores/blogStore';
import { computed, onMounted } from 'vue';
import { useJournalSeo } from '../../../composables/seo';

const route = useRoute();
const blogStore = useBlogStore();

const blogHandle = computed(() => route.params.blogHandle);

console.log('Blog Handle:', blogHandle.value);

const blog = await blogStore.fetchBlogByHandle(blogHandle.value);

//const blog = computed(() => blogStore.blogsByHandle[blogHandle.value] || null);


const excludedTag = 'Excluded';

// Filter dynamic articles
const filteredArticles = computed(() => {
  return blog.articles
    .filter(article => !article.tags?.includes(excludedTag))
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)) || [];
});

// Merge static and dynamic articles into one array
const mergedArticles = computed(() => {
  const staticArticle = {
    handle: 'the-gravaa-story',
    title: 'The Gravaa Story',
    excerpt: 'Discover the full story of how Gravaa started and what drives our journey.',
    image: {
      src: 'https://cdn.shopify.com/s/files/1/0901/6521/5606/files/thegravaastoryhero.jpg?v=1746535852'
    },
    isStatic: true
  };
  return [staticArticle, ...filteredArticles.value];
});

/*onMounted(() => {
  if (!blogStore.blogsByHandle[blogHandle.value]) {
    blogStore.fetchBlogByHandle(blogHandle.value);
  }
});*/

useJournalSeo(blog);
</script>

<style scoped>
@reference "../../../assets/css/main.css";

.article-hover {
  @apply transition-transform duration-500 ease-in;
}

.article-hover:hover .article-image {
  @apply scale-[1.03] transition-transform duration-500 ease-in;
}

.article-hover h4 {
  @apply relative pb-1 inline-block;
}

.article-hover h4::before {
  content: "";
  width: 100%;
  transform: scaleX(0);
  transform-origin: left;
  @apply absolute left-0 bottom-0 h-[1px] bg-black transition-transform duration-500 ease-in;
}

.article-hover:hover h4::before {
  transform: scaleX(1);
}

@media (max-width: 480px) {
  .mb-32 {
    margin-bottom: 64px !important;
  }
}
</style>
